import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

export default React.memo(function PreLoader() {
  return <LinearProgress />;
});
